module.exports = __webpack_public_path__ + "img/t5-teal.8126733c.png";